/* eslint-disable no-unused-vars */
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Button, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import PAutoCompleteMultiSelect from ".././../../components/pos/PAutoCompleteMultiSelect";
import { StringUtils } from "../../../utils/StringUtils";
import Card from "../../../components/Card/Card.js";

export default function ProductPromotionView(props) {
  const { t } = useTranslation();
  const [productLevelPromotions, setProductLevelPromotions] = useState([]);
  const [promotionPrice, setpromotionPrice] = useState("");
  const [promotionPriceError, setpromotionPriceError] = useState("");
  const [promotionOptions, setPromotionOptions] = useState([]);
  const translate = t;

  useEffect(() => {
    let arr = [];
    let options = [...props.tableMeta.tableData[props.tableMeta.rowIndex][7].o];
    let newOptions = [];

    for (let o of options) {
      let found = false;
      for (let pr of props.promotionList) {
        if (o.value.id == pr.value.id) {
          found = true;
        }
      }
      if (!found) {
        newOptions.push(o);
      }
    }
    setPromotionOptions(newOptions);
  }, [props.promotionList]);

  useEffect(() => {
    if (props.tableMeta) {
      if (props.promotionList.length === 0) {
        showProductPromotionView(props.tableMeta);
      }
    }
    let options = [...props.tableMeta.tableData[props.tableMeta.rowIndex][7].o];
    setPromotionOptions(options);
  }, []);

  useEffect(() => {
    let d = [];
    for (let promos of props.promotionList) {
      console.log("39PR:", promos);
      if (
        promos.value.ruleConfigList[0].ruleType.code === "PRODUCT_LEVEL_PRICING"
      ) {
        let o = { ...promos.value };
        o["promotionPrice"] = getPromotionPrice(o.id);
        d.push(o);
      }
    }
    setProductLevelPromotions(d);
  }, [props.promotionList]);

  function getPromotionPrice(id) {
    if (props.tableMeta.tableData[props.tableMeta.rowIndex][7].v2) {
      if (props.tableMeta.tableData[props.tableMeta.rowIndex][7].v2) {
        return props.tableMeta.tableData[props.tableMeta.rowIndex][7].v2[id]
          ? props.tableMeta.tableData[props.tableMeta.rowIndex][7].v2[id]
          : "";
      }
    }
    return "";
  }

  function showProductPromotionView(tableMeta) {
    let tempPromotionList = tableMeta.tableData[tableMeta.rowIndex][7].v;
    props.setPromotionList(tempPromotionList);
  }

  async function onSave() {
    if (validate()) {
      let tempPricingData = [...props.tableMeta.tableData];
      tempPricingData[props.tableMeta.rowIndex][7].v = props.promotionList;
      tempPricingData[props.tableMeta.rowIndex][7]["v2"] =
        getProductLevelPricing();
      console.log("PR1", tempPricingData);
      props.setPricingData(tempPricingData);
      props.onCloseWindow();
    }

    //props.showMessage("success", translate("Saved sucessfully"));
  }

  function validate() {
    let flag = true;
    let arr = [...productLevelPromotions];
    for (let promo of arr) {
      if (!promo.promotionPrice || promo.promotionPrice === "") {
        promo["promotionPriceError"] = "Price required";
        flag = false;
      }
    }
    setProductLevelPromotions(arr);
    return flag;
  }

  function getProductLevelPricing() {
    let d = {};
    for (let promo of productLevelPromotions) {
      d[promo.id] = promo.promotionPrice;
    }
    return d;
  }

  return (
    <div>
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Divider style={{ marginBottom: "5px" }} />
            <PAutoCompleteMultiSelect
              options={promotionOptions}
              value={props.promotionList}
              onChange={(e, value) => {
                props.setPromotionList(value);
              }}
            />
          </Grid>
          <Card>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: "15%" }}>
                    <Typography variant="body1">
                      {translate("Policy Name")}
                    </Typography>
                  </td>
                  <td style={{ width: "12%" }}>
                    <Typography variant="body1">
                      {translate("Start Date")}
                    </Typography>
                  </td>
                  <td style={{ width: "12%" }}>
                    <Typography variant="body1">
                      {translate("End Date")}
                    </Typography>
                  </td>
                  <td style={{ width: "4%" }}>
                    <Typography variant="body1">
                      {translate("Price")}
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </table>
          </Card>
          <Card>
            {productLevelPromotions.map((promo, ix) => (
              <Card>
                <Grid item xs={15}></Grid>
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "15%" }}>
                        <Typography variant="body1">
                          {promo.policyName}
                        </Typography>
                      </td>

                      <td style={{ width: "12%" }}>
                        <Typography variant="body1">
                          {StringUtils.formatDate(new Date(promo.fromDate), 1)}
                        </Typography>
                      </td>

                      <td style={{ width: "12%" }}>
                        <Typography variant="body1">
                          {StringUtils.formatDate(new Date(promo.toDate), 1)}
                        </Typography>
                      </td>

                      <td style={{ width: "4%" }}>
                        <PText
                          type="number"
                          step="0.01"
                          value={promo.promotionPrice}
                          error={promo.promotionPriceError}
                          // error={promotionPriceError}
                          onChange={(e) => {
                            let d = [...productLevelPromotions];
                            d[ix]["promotionPrice"] = e.target.value;
                            if (e.target.value) {
                              d[ix]["promotionPriceError"] = null;
                            } else {
                              d[ix]["promotionPriceError"] = "Pricing Required";
                            }
                            setpromotionPrice(e.target.value);
                          }}
                        ></PText>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Card>
            ))}
          </Card>
        </Grid>
      </div>
      <div>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              width: "95%",
              position: "absolute",

              bottom: 20,
            }}
          >
            <Divider />
            <table width="100%">
              <tbody>
                <tr>
                  <td width="95%"></td>
                  <td>
                    <Button
                      style={{ marginTop: "5px" }}
                      onClick={onSave}
                      variant="contained"
                      color="primary"
                    >
                      Ok
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
